import React, { useEffect, useState } from 'react';
import { BorderOuterOutlined } from '@ant-design/icons';
import { Form, InputNumber, Select } from 'antd';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default {
    Renderer: (props) => {

        const blockStyle = props.data.blockStyle || {}
        let defaultStyle = { display: "flex", flexDirection: "column" }

        return (
            <div style={{ ...defaultStyle, ...blockStyle }}>
                {props.children}
            </div>
        )

    },
    id: 'block-empty',
    title: t`Block`,
    description: t`Conteneur vide personnalisable.`,
    icon: <BorderOuterOutlined />,
    version: 1,
    allowClickInside: true,
    noStyle: true,
    controls: {
        type: 'custom',
        Component: Controls
    }
}


function Controls(props) {

    const { data, onChange } = props

    const [show, setShow] = useState(true)
    const refreshForm = () => {
        setShow(false)
        setTimeout(() => setShow(true), 100)
    }
    useEffect(() => {
        refreshForm()
    }, [props.lang, props.nodeId, props.device])

    if (!show) {
        return null
    }

    return (
        <Form initialValues={{ flexDirection: "column", ...data?.blockStyle }} onValuesChange={(_, data) => {
            onChange({ blockStyle: data })
        }}>

            <Form.Item label={<Trans>Direction</Trans>} name={"flexDirection"}>
                <Select>
                    <Select.Option value="column"><Trans>Colonnes</Trans></Select.Option>
                    <Select.Option value="row"><Trans>Lignes</Trans></Select.Option>
                </Select>
            </Form.Item>


            <Form.Item label={<Trans>Espacement</Trans>} name={"justifyContent"}>
                <Select>
                    <Select.Option value="center"><Trans>Centré</Trans></Select.Option>
                    <Select.Option value="flex-start"><Trans>Centré au debut</Trans></Select.Option>
                    <Select.Option value="flex-end"><Trans>Centré à la fin</Trans></Select.Option>
                    <Select.Option value="space-between"><Trans>Écarter les éléments</Trans></Select.Option>
                    <Select.Option value="space-around"><Trans>Espacer les éléments</Trans></Select.Option>
                </Select>
            </Form.Item>


            <Form.Item label={<Trans>Alignement</Trans>} name={"alignItems"}>
                <Select>
                    <Select.Option value="center"><Trans>Centré</Trans></Select.Option>
                    <Select.Option value="flex-start"><Trans>Centré au début</Trans></Select.Option>
                    <Select.Option value="flex-end"><Trans>Centré à la fin</Trans></Select.Option>
                </Select>
            </Form.Item>


            <Form.Item label={<Trans>Écart (pixel)</Trans>} name={"rowGap"}>
                <InputNumber />
            </Form.Item>


            <Form.Item label={<Trans>Retour à la ligne</Trans>} name={"flexWrap"}>
                <Select>
                    <Select.Option value="nowrap"><Trans>Sans retour</Trans></Select.Option>
                    <Select.Option value="wrap"><Trans>Avec retour</Trans></Select.Option>
                </Select>
            </Form.Item>

        </Form>
    )
}
